import {SearchFormProps} from "../../common/searchForm/SearchForm.props";
import {OptionType} from "../../common/searchForm/constants/Option.type";
import {CategoryList} from "./Category.type";

export const FaqSearchFormProps: SearchFormProps = {
    options: [
        {
            type: OptionType.TYPE,
            key: "type",
            name: "분류",
            list: CategoryList.map(category => category.type),
            stringList: CategoryList.map(category => category.name),
            value: CategoryList[0].type
        },
        {
            type: OptionType.TEXT,
            key: "keyword",
            name: "검색",
            list: [],
            stringList: [],
            value: ""
        }
    ],
    onSearch: () => {},
    onUpdate: () => {}
}